export { default as NPageHeader, pageHeaderProps } from './src/PageHeader';
